import {Component, inject, Input, OnDestroy} from '@angular/core';
import {ReturnStatuses} from "../../../interfaces/orders-data";
import {finalize, takeUntil} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {BaseService} from "../../../services/base.service";
import {Subject} from "rxjs";
import {HeaderService} from "../../../services/header.service";
import {HttpErrorNotifyService} from "../../../services/http-error-notify.service";

@Component({
  selector: 'app-modal-formation-request-return',
  templateUrl: './modal-formation-request-return.component.html',
  styleUrls: ['./modal-formation-request-return.component.scss']
})
export class ModalFormationRequestReturnComponent extends BaseService implements OnDestroy {
  @Input() orderedProducts;
  @Input() currentOrder;
  @Input() returnStatuses: ReturnStatuses[];
  @Input() deliveryDates;

  private http: HttpClient = inject(HttpClient);
  private headerService: HeaderService = inject(HeaderService);
  private notify: HttpErrorNotifyService = inject(HttpErrorNotifyService);

  public isDestroyed: Subject<boolean> = new Subject<boolean>();
  public isFormationRequestReturn: boolean = false;
  public errorMessageQuantityMaxGood: string = 'Максимальна кількість товару не більше';
  public errorMessageQuantityMinGood: string = 'Мінімальна кількість товару 1';
  public wrongComment: boolean = false;
  public returnComment: string = '';
  public errorCommentMessage: string = '';
  public wrongSelect: boolean = false;
  public wrongSelectDate: boolean = false;
  public statusId: string = '0';
  public errorReasonForReturnMessage: string = '';
  public errorDeliveryDateMessage: string = '';
  public dateDelivery: string = '0';
  public wrongQuantityGood: boolean = false;
  public isModalUserInfo: boolean = false;
  public isDarkBackground: boolean = false;
  // Поки approve_return у роботі - «Сформувати заяву» заблокована: повторний клік
  // створював другу заяву (перевірка дубля на беку - читання без блокування).
  public isSubmitting: boolean = false;
  private formOrderId: number = null;

  openModal() {
    // модалка одна на всі замовлення: незавершена заява по A (причина 4 + дата, коментар)
    // лишалась і при відправці по B міняла йому дату доставки. Для того ж замовлення
    // введене зберігаємо (openModal викликається на кожну відмічену позицію).
    if (this.currentOrder?.id !== this.formOrderId) {
      this.formOrderId = this.currentOrder?.id;
      this.returnComment = '';
      this.statusId = '0';
      this.dateDelivery = '0';
      this.wrongComment = false;
      this.wrongSelect = false;
      this.wrongSelectDate = false;
      this.errorCommentMessage = '';
      this.errorReasonForReturnMessage = '';
      this.errorDeliveryDateMessage = '';
    }

    this.isFormationRequestReturn = true;
    this.isDarkBackground = true;
  }

  inputComment() {
    this.wrongComment = this.returnComment === '';
  }

  changingValue(statusId: string) {
    this.wrongSelect = statusId <= '0';

    if (statusId !== '4') {
      this.wrongSelectDate = false;
      this.errorDeliveryDateMessage = '';
    }
  }

  selectDeliveryDate() {
    this.wrongSelectDate = this.dateDelivery == '0';
  }

  submitFormGoodReturn() {
    if (this.isSubmitting) {
      return;
    }

    let isValidForm: boolean = false;

    for (let op of this.orderedProducts) {
      if (op.pack_id == 777 || op.pack_id == 888 || op.pack_id == 999) {
        continue;
      }

      // У заяву йдуть лише відмічені позиції (і поле кількості в модалці є лише в них) - неправильна
      // кількість у невідміченій мовчки блокувала відправку без жодного видимого повідомлення (#413)
      if (op.checkedReturned !== true) {
        continue;
      }

      if (op.count > op.countMax || op.count <= 0 || op.count === null) {
        this.wrongQuantityGood = true;
        isValidForm = true;
      } else {
        this.wrongQuantityGood = false;
      }
    }

    if (this.returnComment === '') {
      this.wrongComment = true;
      isValidForm = true;
      this.errorCommentMessage = 'Будь ласка залиште коментар';
    } else {
      this.wrongComment = false;
    }

    if (this.statusId <= '0') {
      this.wrongSelect = true;
      isValidForm = true;
      this.errorReasonForReturnMessage = 'Виберіть причину повернення';
    } else {
      this.wrongSelect = false;
    }

    if (this.statusId == '4' && this.dateDelivery == '0') {
      this.wrongSelectDate = true;
      isValidForm = true;
      this.errorDeliveryDateMessage = 'Виберіть дату';
    } else {
      this.wrongSelectDate = false;
      this.errorDeliveryDateMessage = '';
    }

    let ordered_ids_and_counts = []

    this.orderedProducts.map(el => {
      if (el.checkedReturned === true) {
        ordered_ids_and_counts.push({
          id: el.id,
          count: el.count
        })
      }
    });

    if (!isValidForm) {
      this.isSubmitting = true;

      this.http.post(this.apiRoot + 'orders/approve_return', {
        order_id: this.currentOrder.id,
        comment: this.returnComment,
        return_status_id: this.statusId,
        // Дату, обрану під причиною 4 і не скинуту після зміни причини, бек сприймав
        // як запит на зміну дати доставки - і замість повернення міняв дату.
        date_delivery: this.statusId == '4' ? this.dateDelivery : '0',
        ordered_ids_and_counts: ordered_ids_and_counts
      })
        .pipe(
          takeUntil(this.isDestroyed),
          finalize(() => this.isSubmitting = false)
        )
        .subscribe({
          next: (resp: any) => {
            // Бек відмовляє зі статусом 200: [] - жодна позиція не прийнята (вже в іншій заяві),
            // success: false - замовлення не знайдено / дату міняти вже не можна. Раніше будь-яка
            // відповідь закривала форму як успіх, і користувач думав, що заяву подано.
            if (!resp || resp.data !== 'success') {
              this.notify.show('Заяву не сформовано', this.describeReturnError(resp));
              return;
            }

            // isModalUserInfo ніде не показується: форма закривалась мовчки, і клієнт не знав, чи заяву подано.
            // Причина 4 на беку - зміна дати доставки замість повернення, у відповіді свій message.
            if (resp.message === 'Delivery date changed successfully.') {
              this.notify.show('Дату доставки змінено', `Нова дата доставки: ${this.dateDelivery}.`);
            } else {
              this.notify.show('Заяву сформовано', 'Заяву на повернення прийнято в обробку.');
            }

            this.isFormationRequestReturn = false;
            this.isModalUserInfo = true;
            this.isDarkBackground = false;
            this.errorCommentMessage = '';
            this.returnComment = '';
            this.statusId = '0';
            this.dateDelivery = '0';
            this.headerService.rebuildHeaderData.next(true);
          },
          error: () => {
            // Бек створює заяву до відповіді: обрив/5xx не означає, що її немає - повтор дав би дубль
            this.notify.show(
              'Не вдалося отримати відповідь сервера',
              'Заява могла вже сформуватися - перевірте історію замовлень перед повторною відправкою.'
            );
          }
        });
    }
  }

  private describeReturnError(resp: any): string {
    if (Array.isArray(resp)) {
      return 'Обрані товари вже є в іншій заяві на повернення або не можуть бути повернені.';
    }

    if (resp && resp.error === 'The delivery date can only be changed for orders with status New.') {
      return 'Дату доставки можна змінити лише для замовлення у статусі «Новий».';
    }

    if (resp && resp.error === 'Wrong delivery date.') {
      return 'Невірна дата доставки. Оберіть дату зі списку.';
    }

    if (resp && resp.error === 'Order not found') {
      return 'Замовлення не знайдено. Оновіть сторінку.';
    }

    return 'Спробуйте ще раз. Якщо помилка повториться - зверніться до менеджера.';
  }

  closeModal() {
    this.isFormationRequestReturn = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
